/**
 * Veeam Service Provider Console REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Vb365JobItemGroup { 
    /**
     * ID assigned to an organization group.
     */
    id: string;
    /**
     * SID assigned to an on-premises organization group.
     */
    onPremisesSid?: string | null;
    /**
     * Type of an organization group.
     */
    groupType?: Vb365JobItemGroupGroupType | null;
    /**
     * Type of an organization group location.
     */
    readonly locationType?: Vb365JobItemGroupLocationType | null;
    /**
     * Name of an organization group.
     */
    name: string;
    /**
     * Display name of an organization group.
     */
    displayName: string;
    /**
     * Name of a user that manages an organization group.
     */
    readonly managedBy?: string;
    /**
     * URL of an organization group site.
     */
    readonly site?: string;
}
export enum Vb365JobItemGroupGroupType {
    Unknown = 'Unknown',
    Office365 = 'Office365',
    Security = 'Security',
    Distribution = 'Distribution',
    DynamicDistribution = 'DynamicDistribution'
};
export enum Vb365JobItemGroupLocationType {
    Unknown = 'Unknown',
    OnPremises = 'OnPremises',
    Cloud = 'Cloud',
    Hybrid = 'Hybrid'
};



